import { contentItemAction } from '../../actions/contentItemActions';
import { menuAction } from '../../actions/menuActions';
import { trackingAction } from './student/tracking/itemsTrackingActions';
import { Quiz } from '@ael/core-api';
import * as Immutable from 'immutable';

export interface CurrentQuizReducerState {
  currentContentItem: string | null;
  answersCorrectFirstTime: Immutable.List<boolean>;
  displayResults: boolean;
}

const initialState: CurrentQuizReducerState = {
  currentContentItem: null,
  answersCorrectFirstTime: Immutable.List<boolean>(),
  displayResults: false,
};

export function currentQuizReducer(
  state: CurrentQuizReducerState = initialState,
  action: any
): CurrentQuizReducerState {
  switch (action.type) {
    case menuAction.SideMenu_SelectedQuiz: {
      const quiz: Quiz = action.payload;
      return {
        currentContentItem: quiz.contentItems.first(),
        answersCorrectFirstTime: Immutable.List<boolean>(),
        displayResults: false,
      };
    }
    case contentItemAction.Quiz_SubmitAnswer:
      return {
        currentContentItem: action.payload.nextQuestion,
        answersCorrectFirstTime: state.answersCorrectFirstTime.push(action.payload.rightFirstTime),
        displayResults: !action.payload.nextQuestion,
      };
    case contentItemAction.SequencedContent_Finish_Selected:
    case menuAction.SideMenu_DeselectItem:
    case menuAction.SideMenu_NavigateBack:
    case menuAction.SideMenu_SelectedSubmenuItem:
    case menuAction.SideMenu_SelectNonSequencedFlowItem:
    case menuAction.SideMenu_SelectSequencedFlowItem:
    case menuAction.SideMenu_SelectedResource:
    case trackingAction.Tracking_ResetProgress:
      return initialState;
    default:
      return state;
  }
}
